import { render } from "./Upgrade.vue?vue&type=template&id=037a9160"
import script from "./Upgrade.vue?vue&type=script&lang=js"
export * from "./Upgrade.vue?vue&type=script&lang=js"

import "./Upgrade.vue?vue&type=style&index=0&id=037a9160&lang=scss"
script.render = render

export default script